export type Replace = { searchValue: string | RegExp; replaceValue: string };
